/* unplugin-vue-components disabled */import { render } from "./richAssembly.vue?vue&type=template&id=1b45c5e8&scoped=true"
import script from "./richAssembly.vue?vue&type=script&lang=js"
export * from "./richAssembly.vue?vue&type=script&lang=js"

import "./richAssembly.vue?vue&type=style&index=0&id=1b45c5e8&scoped=true&lang=css"

import exportComponent from "E:\\work\\weitu_land_page_h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b45c5e8"]])

export default __exports__